// Path builder for the games-side storage. EVERY persisted path goes through
// gpath(), which hard-prefixes the dedicated `ggGames/` root. This is the wall:
// the games side can only ever address nodes under ggGames/, never
// tournaments/* or any other tourney node. Pure (no Firebase import) so the
// isolation is unit-testable.
export const GG_GAMES_ROOT = 'ggGames'

export function gpath(...parts) {
  return [GG_GAMES_ROOT, ...parts.filter((p) => p != null && p !== '')].map(String).join('/')
}
